export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-sidebar/index.ts